import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../routes/Routes';
import { MultipleOptionsTemplate } from '@templates';
import {
  parseZodErrors,
  stringFieldSchema,
} from '@highways/utils/zod-validations';
import { useEffect, useState } from 'react';
import { DEFECT_OPTIONS_ERROR } from '@highways/constants/errorMessages';
import { useHighwaysStore } from '@highways/store/store';
import { ZodError } from 'zod';
import { ErrorMessages } from '@types';
import { HighwaysDamageType } from '@highways/constants/damageTypes';
import { scrollTop } from '@utils';

/**
 * This is a placeholder page only which will be addressed in a separate ticket
 */
export const WhatIsCausingTheIssuePage = () => {
  const navigate = useNavigate();
  const { damageTypeOptions, updateDamageType, damageType, highwaysType } =
    useHighwaysStore();
  const [selectedType, setSelectedType] = useState<HighwaysDamageType | null>(
    damageType,
  );
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);

  // redirect to the landing page if the highwaysType is not set
  useEffect(() => {
    if (!highwaysType || !damageTypeOptions) {
      navigate(RoutesList.TEST_LANDING_PAGE);
    }
  }, []);

  if (damageTypeOptions === null) {
    return null;
  }

  const title = 'What is causing the issue?';

  const options = damageTypeOptions.map((type) => ({
    id: type.title,
    name: type.title,
    labelText: type.title,
    description: type.description,
    radio: type.title,
    imageSrc: type.image,
    isDefault: type.title === damageType,
  }));

  const buttonPrevious = {
    label: 'Previous',
    onClick: () => {
      navigate(RoutesList.HIGHWAYS_DAMAGE);
      scrollTop();
    },
  };
  const buttonNext = {
    label: 'Next',
    onClick: () => {
      try {
        const validatedData = stringFieldSchema(
          'damageType',
          DEFECT_OPTIONS_ERROR.required.message,
        ).parse({
          damageType: selectedType || '',
        });

        updateDamageType(validatedData.damageType as HighwaysDamageType);

        navigate(RoutesList.UPLOAD_PHOTO);
        scrollTop();
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            href: error.path,
          })),
        );
      }
    },
  };

  const onChange = (result: string) => {
    setSelectedType(result as HighwaysDamageType);
    setErrorMessages([]);
  };

  return (
    <MultipleOptionsTemplate
      title={title}
      options={options}
      buttonPrevious={buttonPrevious}
      buttonNext={buttonNext}
      onChange={onChange}
      errorPath={'damageType'}
      errorMessages={errorMessages}
    />
  );
};
